<div class="p-a-5 p-l-2-s p-r-2-s">
    <div class="h3">
        <button class="pos-absolute right-4 top-3 cursor-pointer button-icon"
                type="button"
                (click)="close()"
                aria-label="Close modal window">
            <i [style.font-size.px]="16"
               aria-hidden="true"
               class="icon-close"></i>
        </button>

        <ng-content select="[title]"></ng-content>
    </div>

    <div class="custom-scrollbar _body">
        <ng-content select="[content]"></ng-content>
    </div>

    <div class="_hideEmpty">
        <ng-content select="[bottom]"></ng-content>
    </div>
</div>